import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { AppRoutingModule } from "src/app/app-routing.module";
import { SynchpcConfigureComponent } from "./components/synchpc-setting/synchpc-configure.component";
import { ConfigSectionModule } from "../pages/config-section/config-section.module";
import { LogViewerComponent } from './components/log-viewer/log-viewer.component';

@NgModule({
  declarations: [
    SynchpcConfigureComponent,
    LogViewerComponent
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    NgbModule,
    FormsModule,
    ConfigSectionModule
  ]
})
export class SyncHpcModule { }
